import { AppShellSkeleton } from '@/components/core';
import { useOidcActivation } from '@/modules/auth/hooks/use-oidc-activation';

/** Signing in after the identity provider's redirect: the app shell's skeleton until the app opens (LOAD-01). */
export const OidcCallbackPage = () => {
  useOidcActivation();

  return <AppShellSkeleton />;
};
